/* =========================================================
   NEW STORE FIELD IDS
   Agar kabhi store / fields dobara banen to sirf yahan IDs badlein
   ========================================================= */
const FIELD_IDS = {
  name:          '6ac661bcba350db4f41e384c',
  event:         '6ac66db3ba350db4f41e39c5',
  customEvent:   '6ac66f80ba350db4f41e39e7',
  message:       '6ac67697ba350db4f41e3a95',
  customMessage: '6ac674b9ba350db4f41e3a6a'
};

// Listener sirf ek baar lagay (har keystroke par duplicate na hon)
function bindOnce(el, key, fn) {
  if (!el || el.dataset[key]) return;
  el.dataset[key] = '1';
  fn(el);
}

function updateCharLength(input) {
  const max = input.getAttribute('maxlength') || 0;
  const length = input.value.length;
  const counter = input.closest('.product-custom-field-input-container')
    ?.querySelector('.product-custom-field-character-length');
  if (counter) counter.innerText = `${length} / ${max}`;
}

// Letters/numbers ke ilawa keys block (229 = mobile keyboard, allow)
const ALLOWED_KEYS = [8, 9, 32, 37, 38, 39, 40, 46, 229];

$(document).ready(function() {

  var allowClickAction = false;

  $(document).on('input change', '.product-custom-field-input', function() {
    var selectedRadio = $('input[type="radio"][name^="Image-1"]:checked');
    const items = $('.thumbnail-list li.thumbnail-list__item');
    const thirdLast = items.eq(-3);
    const secondLast = items.eq(-2);
    const last = items.eq(-1);

    thirdLast.addClass('third-last not-hide');
    secondLast.addClass('second-last not-hide');
    last.addClass('last not-hide');

    setTimeout(function() {
      allowClickAction = true;
    }, 1000);

    var overlayContainer = $();

    if (selectedRadio.val() == 'Male') {
      if (allowClickAction && $('.thumbnail-list .third-last button').attr('aria-current') !== 'true') {
        $('.thumbnail-list .third-last button').trigger('click');
      }
      overlayContainer = $('.product__media-wrapper .third-last-male .product-media-container');
    } else if (selectedRadio.val() == 'Female') {
      if (allowClickAction && $('.thumbnail-list .second-last button').attr('aria-current') !== 'true') {
        $('.thumbnail-list .second-last button').trigger('click');
      }
      overlayContainer = $('.product__media-wrapper .second-last-female .product-media-container');
    } else if (selectedRadio.val() == 'Al-Aqsa') {
      if (allowClickAction && $('.thumbnail-list .last button').attr('aria-current') !== 'true') {
        $('.thumbnail-list .last button').trigger('click');
      }
      overlayContainer = $('.product__media-wrapper .last-dome .product-media-container');
    } else {
      console.log('the else statement');
    }

    var parentContainer = $(this).closest('.product-custom-field-input-container');
    var inputVal = $(this).val();
    var labelText = parentContainer.siblings('label').text().toLowerCase();
    var event_text = $(this).siblings('label').text().toLowerCase();

    var overlayClass = '';
    var overlayText = '';

    if (labelText.includes('name')) {

      const nameInput = document.getElementById('product-custom-field-' + FIELD_IDS.name);

      bindOnce(nameInput, 'nameBound', function(input) {
        // Sirf letters aur space
        input.addEventListener('input', function(e) {
          e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
          shrinkOverlayText('.overlay-text.name-overlay');
        });

        input.addEventListener('keydown', function(e) {
          if (ALLOWED_KEYS.includes(e.keyCode)) return;
          if (!(e.keyCode >= 65 && e.keyCode <= 90)) e.preventDefault();
        });

        input.addEventListener('keyup', function() {
          shrinkOverlayText('.overlay-text.name-overlay');
        });
      });

      overlayClass = 'name-overlay';
      overlayText = inputVal;

    } else if (event_text.includes('event') || labelText.includes('event')) {

      overlayClass = 'event-overlay';
      overlayText = inputVal;

      const eventInput = document.getElementById('product-custom-field-' + FIELD_IDS.customEvent);

      bindOnce(eventInput, 'eventBound', function(input) {
        input.addEventListener('input', function(e) {
          e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
          updateCharLength(this);
        });

        input.addEventListener('keydown', function(e) {
          if (ALLOWED_KEYS.includes(e.keyCode)) return;
          if (!((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90))) {
            e.preventDefault();
          }
        });
      });

      // Swatch (select) se value aayi to Custom Event text field sync karo
      if ($(this).is('select')) {
        $('.product-custom-field-input').each(function() {
          if ($(this).is('input[type="text"]') &&
              $(this).parents('.product-custom-field-input-container').siblings('label').text().toLowerCase().includes('event')) {
            var spaceKeyEvent = $.Event('keydown', { keyCode: 32, which: 32 });
            $(this).val(inputVal).trigger('focus').trigger(spaceKeyEvent);
            $('input[name="properties[Event]"]').val(inputVal);
            updateCharLength(this);
          }
        });
      }

    } else if (event_text.includes('message') || labelText.includes('message')) {

      overlayClass = 'message-overlay';
      overlayText = inputVal;

      const messageInput = document.getElementById('product-custom-field-' + FIELD_IDS.customMessage);

      bindOnce(messageInput, 'messageBound', function(input) {
        input.addEventListener('input', function(e) {
          e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
          updateCharLength(this);
        });

        input.addEventListener('keydown', function(e) {
          if (ALLOWED_KEYS.includes(e.keyCode)) return;
          if (!((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90))) {
            e.preventDefault();
          }
        });
      });

      // Swatch (select) se value aayi to Custom Message text field sync karo
      if ($(this).is('select')) {
        $('.product-custom-field-input').each(function() {
          if ($(this).is('input[type="text"]') &&
              $(this).parents('.product-custom-field-input-container').siblings('label').text().toLowerCase().includes('message')) {
            var spaceKeyEvent = $.Event('keydown', { keyCode: 32, which: 32 });
            $(this).val(inputVal).trigger('focus').trigger(spaceKeyEvent);
            $('input[name="properties[Special Message]"]').val(inputVal);
            updateCharLength(this);
          }
        });
      }

    } else {
      console.log('Other input:', inputVal);
      return;
    }

    // Variant select na ho ya image na mile to crash na ho
    if (!overlayContainer.length) {
      console.log('Overlay container not found for:', overlayClass);
      return;
    }

    if (overlayClass === 'name-overlay') {
      var existingName = overlayContainer.find('.' + overlayClass);
      if (existingName.length === 0) {
        overlayContainer.append($('<div class="overlay-text ' + overlayClass + '"></div>').text(overlayText));
      } else {
        existingName.text(overlayText);
      }
    } else {
      var wrapper = overlayContainer.find('.overlay-wrapper');
      if (wrapper.length === 0) {
        wrapper = $('<div class="overlay-wrapper"></div>');
        overlayContainer.css('position', 'relative').append(wrapper);
      }

      var existingOverlay = wrapper.find('.' + overlayClass);
      if (existingOverlay.length === 0) {
        wrapper.append($('<div class="overlay-text ' + overlayClass + '"></div>').text(overlayText));
      } else {
        existingOverlay.text(overlayText);
      }
    }

    $('.overlay-text.name-overlay').css({
      position: 'absolute',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.6)',
      width: '100%',
      textAlign: 'center'
    });

    $('.name-overlay').css({
      top: '5%',
      zIndex: 1,
      color: '#F5D201',
      fontFamily: 'Anothershabby, sans-serif',
      transform: 'rotate(-7deg)'
    });

    shrinkOverlayText('.overlay-text.name-overlay');
  });

  $(document).on('change', '[id^="variant-selects-template--"] input[type="radio"]', function() {

    var hasValue = false;
    $('.product-custom-field-input').each(function() {
      if ($(this).val() !== '') {
        hasValue = true;
        return false;
      }
    });

    if (hasValue) {
      setTimeout(function() {
        const isMobile = window.innerWidth <= 768;

        $('.product-custom-field-input').trigger('input');
        document.activeElement?.blur();

        if (!isMobile) {
          $('.thumbnail-list .thumbnail-list__item:first-child button').trigger('click');
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setTimeout(function() {
            $('.thumbnail-list .thumbnail-list__item:first-child button').trigger('click');
          }, 100);
        }
      }, 1000);
    }
  });

  function showLoader() {
    const loader = document.querySelector('.product-form__submit .loading__spinner');
    const btn = document.querySelector('.product-form__submit');
    if (loader) loader.classList.remove('hidden');
    if (btn) {
      btn.classList.add('loaderbtn');
      btn.disabled = true;
    }
  }

  function hideLoader() {
    const loader = document.querySelector('.product-form__submit .loading__spinner');
    const btn = document.querySelector('.product-form__submit');
    if (loader) loader.classList.add('hidden');
    if (btn) {
      btn.classList.remove('loaderbtn');
      btn.disabled = false;
    }
  }

  function openCartDrawer(cartDrawer, sections) {
    cartDrawer.renderContents({ sections: sections });
    cartDrawer.classList.remove('is-empty');
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }

  $('.product-form__submit').on('click', function(event) {
    event.preventDefault();
    showLoader();

    var customEventInput = document.querySelector('input[name="properties[Custom Event]"]');
    var eventInput = document.querySelector('input[name="properties[Event]"]');
    if (customEventInput && customEventInput.value.trim() !== '' && eventInput) {
      eventInput.value = '';
    }

    var customMessageInput = document.querySelector('input[name="properties[Custom Special Message]"]');
    var messageInput = document.querySelector('input[name="properties[Special Message]"]');
    if (customMessageInput && customMessageInput.value.trim() !== '' && messageInput) {
      messageInput.value = '';
    }

    var formData = $(this).closest('form').serialize();
    formData += '&sections=cart-drawer,cart-icon-bubble';
    formData += '&sections_url=' + window.location.pathname;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',

      success: function(response) {
        hideLoader();
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && response.sections) {
          openCartDrawer(cartDrawer, response.sections);
        } else {
          fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(res => res.json())
            .then(data => {
              if (cartDrawer) openCartDrawer(cartDrawer, data);
            })
            .catch(err => console.error(err));
        }
      },

      error: function(response) {
        hideLoader();
        console.log('Error:', response);
      }
    });
  });

  // Male / Female / Dome images par overlay PNG lagana
  var observer = new MutationObserver(function() {
    const items = $('.product__media-list li.product__media-item');
    items.eq(-3).addClass('third-last-male');
    items.eq(-2).addClass('second-last-female');
    items.eq(-1).addClass('last-dome');

    if ($('.product__media-wrapper .third-last-male .overlay-image').length === 0) {
      $('.product__media-wrapper .third-last-male .product-media-container').append(
        $('<img class="overlay-image manover" src="https://cdn.shopify.com/s/files/1/0342/8912/3459/files/man-overlay.png?v=1752239874" style="position: absolute; bottom: 0; width: 100%; z-index: 2;">')
      );
    }

    if ($('.product__media-wrapper .second-last-female .overlay-image').length === 0) {
      $('.product__media-wrapper .second-last-female .product-media-container').append(
        $('<img class="overlay-image womanover" src="https://cdn.shopify.com/s/files/1/0342/8912/3459/files/women-overlay.png?v=1752228805" style="position: absolute; bottom: 0; width: 100%; z-index: 2;">')
      );
    }

    if ($('.product__media-wrapper .last-dome .overlay-image').length === 0) {
      $('.product__media-wrapper .last-dome .product-media-container').append(
        $('<img class="overlay-image domeover" src="https://cdn.shopify.com/s/files/1/0342/8912/3459/files/dome-overlay-1.png?v=1753449955" style="position: absolute; bottom: 0; width: 100%; z-index: 2;">')
      );
    }

    observer.disconnect();
  });

  observer.observe(document, { childList: true, subtree: true });

  // Custom fields load hon to existing values se preview trigger karo
  function checkForElement() {
    const observer_event = new MutationObserver(function() {
      if ($('.product-custom-field-input-container').length) {
        $('.product-custom-field-input').each(function() {
          if ($(this).val() !== '') {
            $(this).trigger('input');
            $(this).trigger('change');
          }
        });
        observer_event.disconnect();
      }
    });

    observer_event.observe(document.body, { childList: true, subtree: true });
  }

  checkForElement();
});

/* =========================================================
   SELECT -> SWATCH BUTTONS
   ========================================================= */
$(document).ready(function() {
  var checkElementInterval = setInterval(function() {
    if (!$('.product-custom-fields-container .product-custom-field-item').length) return;
    clearInterval(checkElementInterval);

    $('select.product-custom-field-input').each(function() {
      var $originalSelect = $(this);

      // Pehle se swatch bana ho to dobara na banao
      if ($originalSelect.next('.swatch-container').length) {
        $originalSelect.next('.swatch-container').remove();
      }

      var $swatchContainer = $('<div class="swatch-container"></div>');
      $originalSelect.after($swatchContainer);

      $originalSelect.css({
        position: 'absolute',
        opacity: 0,
        'pointer-events': 'none',
        height: 0,
        width: 0
      });

      $originalSelect.find('option').each(function() {
        var optionValue = $(this).val();
        var optionText = $(this).text();
        if (optionValue === '') return;

        $('<div class="swatch-option"></div>')
          .text(optionText)
          .toggleClass('selected', $(this).is(':selected'))
          .click(function() {
            if ($swatchContainer.hasClass('dragging')) return;

            $originalSelect.val(optionValue);
            $swatchContainer.find('.swatch-option').removeClass('selected');
            $(this).addClass('selected');

            $originalSelect.trigger('change');
            $originalSelect[0].dispatchEvent(new Event('change', { bubbles: true }));

            if (typeof CustomFields !== 'undefined' && typeof CustomFields.onInputChange === 'function') {
              CustomFields.onInputChange($originalSelect[0]);
            }
          })
          .appendTo($swatchContainer);
      });

      // Mouse drag scroll
      let isDown = false;
      let startX;
      let scrollLeft;

      $swatchContainer.on('mousedown', function(e) {
        isDown = true;
        startX = e.pageX - $swatchContainer.offset().left;
        scrollLeft = $swatchContainer.scrollLeft();
        $swatchContainer.addClass('dragging');
      });

      $(document).on('mouseup', function() {
        isDown = false;
        $swatchContainer.removeClass('dragging');
      });

      $(document).on('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - $swatchContainer.offset().left;
        $swatchContainer.scrollLeft(scrollLeft - (x - startX) * 2);
      });

      $originalSelect.on('change', function() {
        var selectedText = $originalSelect.find('option:selected').text();
        $swatchContainer.find('.swatch-option').removeClass('selected')
          .filter(function() { return $(this).text() === selectedText; })
          .addClass('selected');
      });
    });
  }, 100);
});

/* =========================================================
   DEFAULT VALUES + PREVIEW BUTTON
   ========================================================= */
document.addEventListener('DOMContentLoaded', function() {

  const nameInputSelector     = '#product-custom-field-' + FIELD_IDS.name;
  const eventSelectSelector   = 'select[name="' + FIELD_IDS.event + '"]';
  const messageSelectSelector = 'select[name="' + FIELD_IDS.message + '"]';

  function fillNameField(value) {
    const input = document.querySelector(nameInputSelector);
    if (!input) return;

    const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeSetter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.blur();
  }

  function selectSwatchAndSync(selectEl, textValue) {
    if (!selectEl) return;

    const item = selectEl.closest('.product-custom-field-item');
    const swatches = item ? item.querySelectorAll('.swatch-option') : [];

    swatches.forEach(function(swatch) {
      const isMatch = swatch.textContent.trim().toLowerCase() === textValue.toLowerCase();
      swatch.classList.toggle('selected', isMatch);
      if (isMatch) swatch.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });

    for (const opt of selectEl.options) {
      if (opt.textContent.trim().toLowerCase() === textValue.toLowerCase()) {
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }

  function goToVariantImage() {
    var selectedRadio = $('input[type="radio"][name^="Image-1"]:checked');
    var map = { 'Male': 'third-last', 'Female': 'second-last', 'Al-Aqsa': 'last' };
    var cls = map[selectedRadio.val()];
    if (!cls) return;

    if (window.innerWidth <= 768) window.scrollTo({ top: 0, behavior: 'smooth' });

    var $btn = $('.thumbnail-list .' + cls + ' button');
    if ($btn.attr('aria-current') !== 'true') $btn.trigger('click');
  }

  function addPreviewButton() {
    const existing = document.querySelector('.preview-button');
    if (existing) existing.remove();

    const previewButton = document.createElement('button');
    previewButton.className = 'button preview-button';
    previewButton.type = 'button';
    previewButton.innerHTML = `
  <svg viewBox="0 0 1280 1042.0374" width="20" height="20" fill="#fff" class="mr-2">
    <path d="M512 192q-84 0-161 23-77 24-143 66T89 382Q36 441 0 512q36 71 89 130t119 101q66 42 143 66 77 23 161 23t161-23q77-24 143-66t119-101q53-59 89-130-36-71-89-130T816 281q-66-42-143-66-77-23-161-23zm252 170q46 28 83.5 66.5T914 512q-29 45-66.5 83.5T764 662q-56 36-120.5 55T512 736q-67 0-131.5-19T260 662q-46-28-83.5-66.5T110 512q29-45 66.5-83.5T260 362q2-2 5-4l6-4q-7 21-11 43t-4 45q0 53 20 100 20 46 55 81t81 55q47 20 100 20t100-20q46-20 81-55t55-81q20-47 20-100 0-23-4-45t-11-43l6 4q3 2 5 4zm-252 54q0 40-28 68t-68 28q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68z"/>
  </svg> Preview Now`;

    const buttons = document.querySelector('.product-form__buttons');
    if (buttons) buttons.appendChild(previewButton);

    previewButton.addEventListener('click', goToVariantImage);
  }

  function handleVariantCheckAndFill() {
    const selectedVariant = document.querySelector('input[type="radio"][name^="Image-"]:checked');
    const variantTitle = selectedVariant?.value?.trim().toLowerCase() || '';

    const eventSelect = document.querySelector(eventSelectSelector);
    const messageSelect = document.querySelector(messageSelectSelector);

    addPreviewButton();

    if (!eventSelect || !messageSelect) {
      console.log('Event/Message select not found - FIELD_IDS check karein');
      return;
    }

    // NOTE: 'female' pehle check hona zaroori hai kyunki 'female' mein 'male' bhi hai
    if (variantTitle.includes('female')) {
      fillNameField('Imaan');
      selectSwatchAndSync(eventSelect, 'Nikah Mubarak');
      selectSwatchAndSync(messageSelect, 'May Your Duas Be Answered');
    } else if (variantTitle.includes('male')) {
      fillNameField('Mohammed');
      selectSwatchAndSync(eventSelect, 'For Palestine');
      selectSwatchAndSync(messageSelect, 'Because every name counts');
    } else if (variantTitle.includes('al-aqsa')) {
      fillNameField('Omer');
      selectSwatchAndSync(eventSelect, 'Umrah Mubarak');
      selectSwatchAndSync(messageSelect, 'May Your Duas Be Answered');
    } else {
      fillNameField('');
    }

    document.activeElement?.blur();
    window.scrollTo(0, 0);
  }

  // Fields load hone ka wait
  const waitForInputs = new MutationObserver(function() {
    if (document.querySelector(nameInputSelector) &&
        document.querySelector(eventSelectSelector) &&
        document.querySelector(messageSelectSelector)) {
      waitForInputs.disconnect();
      setTimeout(handleVariantCheckAndFill, 300);
    }
  });
  waitForInputs.observe(document.body, { childList: true, subtree: true });

  // Variant change
  document.body.addEventListener('change', function(e) {
    if (e.target.matches('select[name="id"]') ||
        e.target.matches('.product__radio input[type="radio"]')) {
      setTimeout(handleVariantCheckAndFill, 300);
    }
  });

  setTimeout(handleVariantCheckAndFill, 1000);
});

/* =========================================================
   NAME TEXT AUTO SHRINK
   ========================================================= */
function shrinkOverlayText(selector, minFontSize = 10) {
  document.querySelectorAll(selector).forEach(function(el) {
    el.style.fontSize = '90px';
    const containerWidth = el.clientWidth;
    let fontSize = parseFloat(window.getComputedStyle(el).fontSize);

    while (el.scrollWidth > containerWidth && fontSize > minFontSize) {
      fontSize -= 1;
      el.style.fontSize = fontSize + 'px';
    }
  });
}

shrinkOverlayText('.overlay-text.name-overlay');

window.addEventListener('resize', function() {
  shrinkOverlayText('.overlay-text.name-overlay');
});